import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col-11 col-sm-8 col-md-6 col-lg-4 mx-auto mt-5" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, "仮申込み", -1)
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "card-title" }, [
  /*#__PURE__*/_createTextVNode(" お申込みありがとうございます。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" メールアドレスを入力し、登録ボタンをクリックしてください。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" サービス本登録のご案内を送信します。 ")
], -1)
const _hoisted_6 = ["onSubmit"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "text-center my-3" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn btn-primary col-4",
    type: "submit"
  }, "登録")
], -1)

import { ref, unref } from 'vue'
import { useRouter } from 'vue-router'
import { useNicotto } from '@/plugins/nicotto'
import { useMessenger } from '@/plugins/message'
import { useValidateForm } from '@/components/ui/validator'
import FormGroup from '@/components/ui/FormGroup.vue'
import InputEmail from '@/components/ui/InputEmail.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'IndexView',
  setup(__props) {

const router = useRouter()
const nicotto = useNicotto()
const messenger = useMessenger()

const email = ref('')

const formRef = ref<HTMLFormElement>()
const onSubmit = async() => {
  const form = unref(formRef) as unknown as HTMLFormElement
  if (useValidateForm(form).isValid()) {
    try {
      await nicotto.auth.signUp(email.value)
      router.push('/application/sendmail')
    } catch (err) {
      messenger.set('application.emailSendFailed')
      form.classList.remove('was-validated')
      form.querySelectorAll('.form-control').forEach(el => {
        el.classList.add('is-invalid')
      })
    }
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("form", {
          ref_key: "formRef",
          ref: formRef,
          onSubmit: _withModifiers(onSubmit, ["prevent"]),
          novalidate: ""
        }, [
          _createVNode(FormGroup, {
            label: "メールアドレス",
            horizontal: false
          }, {
            default: _withCtx(() => [
              _createVNode(InputEmail, {
                modelValue: email.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
                label: "メールアドレス",
                required: true
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _hoisted_7
        ], 40, _hoisted_6)
      ])
    ])
  ]))
}
}

})